<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-custom-select
              ref="siteSelect"
              :selected="selectedCode.SIT"
              :defaultOption="'all'"
              :option-list="siteList"
              @list-clicked="onListClicked"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_TYPE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <cmp-task-id-select
              ref="taskIdSelect"
              :default1LevelOption="'all'"
              :default2LevelOption="'all'"
              :default3LevelOption="'all'"
              :pageId="this.$options.name"
              :applyAuthSiteId="applyAuthSiteId"
              @select-changed="onChangeBizCodes"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USER_GROUP')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="userGroupName"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup="onKeyUpInput"
              @keyup.enter="onSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CORP_NAME')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="selectedCode.applCompany"
              maxlength="50"
              @keyup.enter="onSearch"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_COMP_LOGIN_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="selectedCode.userId"
              maxlength="50"
              @keyup.enter="onSearch"
            />
          </div>
       
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_APPR_STT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="apprSttSelect"
              codeId="COD_AUTH_RQS_STT"
              :page-id="this.$options.name"
              :selected="selectedCode.authRequestStatusCode"
              :defaultOption="'all'"
              :filteredOptionList="filteredOptionList"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_APPL_USER')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="applUser"
              maxlength="50"
              @keyup.enter="onSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_APPL_DATE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="dp"
              v-model="selectedCode.rangeDate"
              @confirm="onRangeConfirm"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="'PGE_CMA_00011'"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grdList"
        :showCountControl="true"
        :showDisplayCountControl="false"
        :pageable="false"
        :sortable="false"
        :filterable="false"
        :columns="gridColumns"
        :columnsresize="true"
        :columnsautoresize="true"
        :enabletooltips="true"
        width="100%"
        :dataset="'dsData'"
        :initialPagesize="10"
      />
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:delete="'PGE_CMA_00011'"
          type="button"
          class="comm_btn_solid"
          @click="onAuthwithDraw"
        >
          {{ $t('MSG_BTN_AUTH_WITHDRAW') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
// 페이지 에서 사용하는 code 목록 기술
export default {
  name: 'PGE_CMA_00011', // eslint-disable-line vue/name-property-casing
  data() {
    return {
      applUser: '',
      applyAuthSiteId: 'ALL',
      searchFieldOldText: '',
      userInfo: {},
      siteList: [],
      filteredOptionList: [
        { key: 'ALL' },
        { key: 'A' },
        { key: 'W' },
      ],
      selectedCode: {
        SIT: { key: '', label: '' },
        rangeDate: {
          from: '',
          to: '',
        },
        authRequestStatusCode: { key: '', labbel: '' },
        applCompany: '',
        userId: '',
      },
      userGroupName: '',
      selectedUser: { userName: '', epId: '' },
      selectedBizCode: [],
      localdata0: [],
      gridColumns: [
        {
          text: '',
          datafield: 'check',
          align: 'center',
          width: '40',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellCheckbox(row, column, value, htmlElement, {
            }, this.dsData, this.$refs.grdList);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },
        {
          text: this.$t('MSG_TXT_SITE'),
          datafield: 'siteName',
          width: '100px',
        },
        {
          text: this.$t('MSG_TXT_TASK_TYPE'),
          datafield: 'taskName',
          width: '250px',
        },
        {
          text: this.$t('MSG_TXT_USER_GROUP'),
          datafield: 'userGroupName',
        },
        {
          text: this.$t('MSG_TXT_APPL_USER'),
          datafield: 'requestUserId',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
              displayType: '1', // "1", "2" - default: "1"
              type: 'link', // 'link', 'sublink' - default: "link"
              datafieldMap: {
                displayLanguageId: 'requestDsplLangId',
                knoxId: 'requestKnoxId',
                userName: 'requestUserName',
                userGlobalName: 'requestUserGlobalName',
              },
            }, this.dsData, this.$refs.grdList);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: '150px',
        },
        {
          text: this.$t('MSG_TXT_CORP_NAME'),
          datafield: 'requestCompanyName',
          width: '200px',
        },
        // {
        //   text: this.$t('MSG_TXT_APPL_CNTN'),
        //   datafield: 'button',
        //   createwidget: (row, column, value, htmlElement) => {
        //     utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
        //       handler: this.onViewRjtOpn,
        //     }, this.dsData, this.$refs.grdList);
        //   },
        //   initwidget(row, column, value, htmlElement) {
        //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        //   },
        //   cellsalign: 'left',
        //   width: '80px',
        // },
        {
          text: this.$t('MSG_TXT_APPL_DTM'),
          datafield: 'requestDTM',
          width: '150px',
        },
        {
          text: this.$t('MSG_TXT_APPROVER'),
          datafield: 'authUserId',
          createwidget: (row, column, value, htmlElement) => {
            if (utils.isEmpty(row.bounddata.authUserId) === false) {
              utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
                displayType: '1', // "1", "2" - default: "1"
                type: 'link', // 'link', 'sublink' - default: "link"
                datafieldMap: {
                  displayLanguageId: 'authDsplLangId',
                  knoxId: 'authKnoxId',
                  userName: 'authUserName',
                  userGlobalName: 'authUserGlobalName',
                },
              }, this.dsData, this.$refs.grdList);
            }
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
          width: '150px',
        },
        {
          text: this.$t('MSG_TXT_APPR_STT'),
          datafield: 'authRequestStatusName',
          width: '100px',
        },
        {
          text: this.$t('MSG_TXT_APPR_DTM'),
          datafield: 'authApprDTM',
          width: '150px',
        },
      ],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsData',
    type: 'local',
    data: 'localdata0',
    datafields: [
      // { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'check', type: 'string', map: 'check' },
      { name: 'siteId', type: 'string', map: 'siteId' },
      { name: 'siteName', type: 'string', map: 'siteName' },
      { name: 'taskId', type: 'string', map: 'taskId' },
      { name: 'taskName', type: 'string', map: 'taskName' },
      { name: 'userGroupId', type: 'string', map: 'userGroupId' },
      { name: 'userGroupName', type: 'string', map: 'userGroupName' },
      { name: 'requestUserId', type: 'string', map: 'requestUserId' },
      { name: 'requestUserName', type: 'string', map: 'requestUserName' },
      { name: 'requestUserGlobalName', type: 'string', map: 'requestUserGlobalName' },
      { name: 'requestDeptId', type: 'string', map: 'requestDeptId' },
      { name: 'requestDeptName', type: 'string', map: 'requestDeptName' },
      { name: 'requestDeptGlobalName', type: 'string', map: 'requestDeptGlobalName' },
      { name: 'requestDsplLangId', type: 'string', map: 'requestDsplLangId' },
      { name: 'requestKnoxId', type: 'string', map: 'requestKnoxId' },
      { name: 'requestCompanyName', type: 'string', map: 'requestCompanyName' },
      { name: 'authRequestReason', type: 'string', map: 'authRequestReason' },
      { name: 'authApprDTM', type: 'string', map: 'authApprDTM' },
      { name: 'authRequestStatusCode', type: 'string', map: 'authRequestStatusCode' },
      { name: 'authRequestStatusName', type: 'string', map: 'authRequestStatusName' },
      { name: 'authRejectUserId', type: 'string', map: 'authRejectUserId' },
      { name: 'authRejectReason', type: 'string', map: 'authRejectReason' },
      { name: 'authRejectDtm', type: 'string', map: 'authRejectDtm' },
      { name: 'authRejectUserIp', type: 'string', map: 'authRejectUserIp' },
      { name: 'authUserId', type: 'string', map: 'authUserId' },
      { name: 'authUserName', type: 'string', map: 'authUserName' },
      { name: 'authUserGlobalName', type: 'string', map: 'authUserGlobalName' },
      { name: 'authDsplLangId', type: 'string', map: 'authDsplLangId' },
      { name: 'authKnoxId', type: 'string', map: 'authKnoxId' },
      { name: 'authRequestUid', type: 'string', map: 'authRequestUid' },
      { name: 'requestDTM', type: 'string', map: 'requestDTM' },
    ],
  }],
  mounted() {
    this.userInfo = this.$store.getters.userInfo;
    this.load();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onChangeBizCodes(optList) {
      this.selectedBizCode = optList;
    },
    onKeyUpInput() {
      const searchFieldNewText = this.userGroupName;

      if (utils.isEmpty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.userGroupName = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    onSelectedUser(selectedData) {
      if (selectedData != null) {
        this.selectedUser.userName = selectedData.userName;
        this.selectedUser.epId = selectedData.epId;
      } else {
        this.selectedUser.userName = '';
        this.selectedUser.epId = '';
      }
    },
    onRangeConfirm(value) {
      this.selectedCode.rangeDate = utils.assign(value);
    },
    onViewRjtOpn(value, dataRow) {
      const inputValue = dataRow.authRequestReason;
      utils.openTextAreaEditor(
        this.onClosePopup,
        {
          title: this.$t('MSG_TXT_AUTH_APPL_RSN'),
          pageInitialData: {
            readonly: true,
            value: inputValue,
            positiveButtonText: this.$t('MSG_BTN_CFRM'),
          },
        },
      );
    },
    onClosePopup() {
    },
    onReset() {
      this.applyAuthSiteId = 'ALL';
      this.$refs.siteSelect.reset();
      this.$refs.taskIdSelect.reset('ALL');
      this.selectedBizCode = [];
      this.$refs.apprSttSelect.reset();
      this.userGroupName = '';
      this.selectedCode.userId = '';
      this.selectedCode.applCompany = '';
      this.applUser = '';
      this.selectedCode.rangeDate = {
        from: '',
        to: '',
      };
    },
    onSearch() {
      if (this.onClickValidate()) return false;
      /*
      if ((this.selectedCode.SIT.key === ' ')
          || (utils.isEmpty(this.selectedCode.SIT.key) === true)) {
        const msg = utils.strFormat(this.$t('MSG_ALT_NCELL_REQUIRED_VAL'), this.$t('MSG_TXT_SITE'));
        utils.messageBox('warning', msg);
        return;
      }
*/
      const siteId = this.selectedCode.SIT.key === 'ALL'
        ? '' : this.selectedCode.SIT.key;

      let taskId = '';
      if (this.selectedBizCode.length === 3) {
        if (this.selectedBizCode[2].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[2].key);
        } else if (this.selectedBizCode[1].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[1].key);
        } else if (this.selectedBizCode[0].key !== 'ALL') {
          taskId = utils.trim(this.selectedBizCode[0].key);
        }
      }

      // if (utils.isEmpty(taskId) === true) {
      //   const msg = utils.strFormat(this.$t('MSG_ALT_NCELL_REQUIRED_VAL'), this.$t('MSG_TXT_TASK_TYPE'));
      //   utils.messageBox('warning', msg);
      //   return;
      // }

      const { from, to } = this.selectedCode.rangeDate;
      const reqFrom = utils.toStringByFormat(from, 'YYYYMMDD');
      const reqTo = utils.toStringByFormat(to, 'YYYYMMDD');

      let sAuthRequestStatusCode = utils.trim(this.selectedCode.authRequestStatusCode.key) || '';
      if (sAuthRequestStatusCode === 'ALL') {
        sAuthRequestStatusCode = 'A;W';
      }

      const queryParams = {
        portalId: 'PEHS',
        siteId: siteId || '',
        taskId: taskId || '',
        apprSttCode: '',
        userGroupName: this.userGroupName || '',
        userId: this.selectedCode.userId || '',
        applCompany: this.selectedCode.applCompany || '',
        applUser: this.applUser || '',
        reqFrom: reqFrom || '',
        reqTo: reqTo || '',
        apprSttCodeFilter: sAuthRequestStatusCode,
      };

      http.request(this.$options.name, 'DTS_CMA_00038', {
        query: queryParams,
      }).then(res => {
        const items = [];
        utils.forEach(res.data, item => {
          const apprDTM = utils.isEmpty(item.authApprovalDTM) === true
            ? '-' : utils.dateformatToClient(item.authApprovalDTM);
          const requestDTM = utils.dateformatToClient(item.firstRegistrationDTM);
          const check = item.authRequestStatusCode === 'A' ? 'N' : 'O';

          items.push({
            check,
            siteId: item.siteId,
            siteName: item.siteName,
            taskId: item.taskId,
            taskName: item.taskName,
            userGroupId: item.userGroupId,
            userGroupName: item.userGroupName,
            requestUserId: item.userId,
            requestUserName: item.userName,
            requestUserGlobalName: item.userGlobalName,
            requestDsplLangId: item.displayLangId,
            requestKnoxId: item.knoxId,
            requestCompanyName: item.companyName,
            authRequestStatusCode: item.authRequestStatusCode,
            authRequestStatusName: item.authRequestStatusName,
            authRequestReason: item.authApprovalOpinionContent,
            authRejectReason: item.authApprovalOpinionContent,
            authApprDTM: apprDTM,
            authUserId: item.authApprovalUserId,
            authUserName: item.authApprovalUserName,
            authUserGlobalName: item.authApprovalUserGlobalName,
            authDsplLangId: item.authApprovalDisplayLangId,
            authKnoxId: item.authApprovalKnoxId,
            authRequestUid: item.authRequestUid,
            requestDTM,
          });
        });
        this.dsData.setRawData(items);
      }).catch(error => {
        console.log(error);
      });

      return null;
    },
    onAuthwithDraw() {
      if (this.dsData.data.length > 0) {
        const paramList = [];

        utils.forEach(this.dsData.data, obj => {
          if (utils.isEqual(obj.check, 'Y') === true) {
            if (utils.isEqual(obj.authRequestStatusCode, 'A') === true) {
              paramList.push({
                authRequestUid: utils.trim(obj.authRequestUid),
              });
            }
          }
        });

        if (paramList.length > 0) {
          utils.messageBox('confirm', this.$t('MSG_ALT_WANT_AUTH_WITHDRAW'), null, () => {
            http.request(this.$options.name, 'DTS_CMA_00054', {
              data: paramList,
            }).then(() => {
              const msg = utils.strFormat(this.$t('MSG_ALT_HAS_BEEN_COMPLETED'), this.$t('MSG_BTN_AUTH_WITHDRAW'));
              utils.messageBox('success', msg);
              this.onSearch();
            }).catch(error => {
              console.log(error);
            });
          });
        } else {
          utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
        }
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
      return true;
    },
    onListClicked(event) {
      // console.log(item);
      // const taskId = utils.trim(event.taskId);
      // if (utils.isEqual(taskId, 'ALL') === true) {
      //   this.$refs.taskIdSelect.reset();
      // } else {
      //   this.$refs.taskIdSelect.setSelectedAllTask(utils.trim(event.taskId), true);
      // }
      this.applyAuthSiteId = event.key;
      this.$refs.taskIdSelect.reset(this.applyAuthSiteId);
    },
    load() {
      http.request(this.$options.name, 'DTS_CMA_00039', {
      }).then(res => {
        this.siteList = [];
        if (res.data.length > 0) {
          utils.forEach(res.data, obj => {
            const siteInfo = {
              key: obj.siteId,
              label: obj.siteName,
              taskId: obj.taskId,
            };
            this.siteList.push(siteInfo);
          });
        }
        this.selectedCode.SIT.key = 'ALL';
      }).catch(error => {
        console.log(error);
      });
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // if (this.onClickValidate()) return false;
      if (!this.$refs.dp.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
